// Backend uses ISO3 codes; flag emoji rendering needs ISO2 — both kept here.
export type CountryEntry = {
  iso2: string;
  iso3: string;
  name: string;
  nationality: string;
};

export const COUNTRIES: ReadonlyArray<CountryEntry> = [
  { iso2: "CO", iso3: "COL", name: "Colombia", nationality: "Colombiana" },
  { iso2: "MX", iso3: "MEX", name: "México", nationality: "Mexicana" },
  { iso2: "AR", iso3: "ARG", name: "Argentina", nationality: "Argentina" },
  { iso2: "CL", iso3: "CHL", name: "Chile", nationality: "Chilena" },
  { iso2: "PE", iso3: "PER", name: "Perú", nationality: "Peruana" },
  { iso2: "EC", iso3: "ECU", name: "Ecuador", nationality: "Ecuatoriana" },
  { iso2: "BR", iso3: "BRA", name: "Brasil", nationality: "Brasileña" },
  { iso2: "PA", iso3: "PAN", name: "Panamá", nationality: "Panameña" },
  { iso2: "US", iso3: "USA", name: "Estados Unidos", nationality: "Estadounidense" },
  { iso2: "ES", iso3: "ESP", name: "España", nationality: "Española" },
];

const byIso3 = new Map(COUNTRIES.map((c) => [c.iso3.toUpperCase(), c]));
const byIso2 = new Map(COUNTRIES.map((c) => [c.iso2.toUpperCase(), c]));

export const flagFromIso2 = (iso2: string | null | undefined): string => {
  if (!iso2 || iso2.length !== 2) return "🌐";
  return (
    iso2
      .toUpperCase()
      .split("")
      .map((ch) => {
        const code = ch.charCodeAt(0);
        if (code < 65 || code > 90) return "";
        return String.fromCodePoint(0x1f1e6 + code - 65);
      })
      .join("") || "🌐"
  );
};

export const flagFromCountryCode = (code: string | null | undefined): string => {
  if (!code) return "🌐";
  const upper = code.toUpperCase();
  if (upper.length === 2) return flagFromIso2(upper);
  if (upper.length === 3) {
    const entry = byIso3.get(upper);
    if (entry) return flagFromIso2(entry.iso2);
  }
  return "🌐";
};

export const countryName = (code: string | null | undefined): string => {
  if (!code) return "—";
  const upper = code.toUpperCase();
  if (upper.length === 2) return byIso2.get(upper)?.name ?? upper;
  if (upper.length === 3) return byIso3.get(upper)?.name ?? upper;
  return upper;
};

export const nationalityLabel = (code: string | null | undefined): string => {
  if (!code) return "—";
  const upper = code.toUpperCase();
  if (upper.length === 2) return byIso2.get(upper)?.nationality ?? upper;
  if (upper.length === 3) return byIso3.get(upper)?.nationality ?? upper;
  return upper;
};
